module.exports = __webpack_public_path__ + "static/media/logo.f9752c7a.png";